import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-alert-information',
    templateUrl: './alert-information.component.html',
    styleUrls: ['./alert-information.component.css'],
    standalone: false
})
export class AlertInformationComponent implements OnInit {

  @Input()
  message!:string;

  constructor() { }

  ngOnInit(): void {
  }

}
